var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmoking = function SvgSmoking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13.25L20.5 18.25M20.5 11.75C20.5 8.98858 18.2614 6.75 15.5 6.75C16.6046 6.75 17.5 5.85457 17.5 4.75C17.5 3.64543 16.6046 2.75 15.5 2.75M14 2.75H12.5C10.567 2.75 9 4.317 9 6.25C9 8.183 10.567 9.75 12.5 9.75H15.5C16.6046 9.75 17.5 10.6454 17.5 11.75M17.5 13.75H2.5C1.94772 13.75 1.5 14.1977 1.5 14.75V16.75C1.5 17.3023 1.94772 17.75 2.5 17.75H17.5V13.75Z",
    stroke: "#282828",
    strokeWidth: 1.5
  })));
};
export default SvgSmoking;